import React from "react";
import "./TalentLenzApplicantEvidenceJourney.css";

import talentlenzApplicantEvidenceJourneyApplicantPhotoWebp from "../../images/talentlenz-applicant-evidence-journey-applicant-photo.webp";
import talentlenzApplicantEvidenceJourneyApplicantPhotoJpg from "../../images/talentlenz-applicant-evidence-journey-applicant-photo.jpg";
import talentlenzApplicantEvidenceJourneyInterface from "../../images/talentlenz-applicant-evidence-journey-interface.svg";
import talentlenzApplicantEvidenceJourneyProfileCompletionIcon from "../../images/talentlenz-applicant-evidence-journey-profile-completion-icon.svg";
import talentlenzApplicantEvidenceJourneyDocumentIcon from "../../images/talentlenz-applicant-evidence-journey-document-icon.svg";
import talentlenzApplicantEvidenceJourneyControlledAssessmentShield from "../../images/talentlenz-applicant-evidence-journey-controlled-assessment-shield.svg";

export default function TalentLenzApplicantEvidenceJourney() {
  return (
    <section className="talentlenz-applicant-evidence-journey" id="talentlenz-applicant-evidence" aria-labelledby="talentlenz-applicant-evidence-journey-title">
      <div className="talentlenz-applicant-evidence-journey__inner">
        <div className="talentlenz-applicant-evidence-journey__copy">
          <p className="talentlenz-applicant-evidence-journey__eyebrow">CAPTURE APPLICANT EVIDENCE</p>
          <h2 id="talentlenz-applicant-evidence-journey-title">Give every applicant one structured journey.</h2>
          <p className="talentlenz-applicant-evidence-journey__body">Applicants complete their profile, upload the documents you require and take the assessment in one guided flow. TalentLenz extracts evidence from submitted CVs and qualifications so every application reaches HR in a consistent format.</p>
        </div>
    
        <div className="talentlenz-applicant-evidence-journey__visual">
          <picture>
            <source srcSet={talentlenzApplicantEvidenceJourneyApplicantPhotoWebp} type="image/webp" />
            <img className="talentlenz-applicant-evidence-journey__photo" src={talentlenzApplicantEvidenceJourneyApplicantPhotoJpg} alt="Illustrative applicant completing a structured online application at home" />
          </picture>
          <img className="talentlenz-applicant-evidence-journey__interface" src={talentlenzApplicantEvidenceJourneyInterface} alt="Profile, evidence and assessment stages in the TalentLenz applicant journey" />
        </div>
    
        <div className="talentlenz-applicant-evidence-journey__details">
          <ul className="talentlenz-applicant-evidence-journey__capabilities" aria-label="Applicant journey stages">
            <li className="talentlenz-applicant-evidence-journey__capability">
              <img src={talentlenzApplicantEvidenceJourneyProfileCompletionIcon} alt="" aria-hidden="true" />
              <strong>Profile complete</strong>
              <span>Details captured</span>
            </li>
            <li className="talentlenz-applicant-evidence-journey__capability">
              <img src={talentlenzApplicantEvidenceJourneyDocumentIcon} alt="" aria-hidden="true" />
              <strong>Evidence uploaded</strong>
              <span>Required documents gathered</span>
            </li>
            <li className="talentlenz-applicant-evidence-journey__capability">
              <img src={talentlenzApplicantEvidenceJourneyControlledAssessmentShield} alt="" aria-hidden="true" />
              <strong>Assessment controlled</strong>
              <span>Configured limits and integrity controls</span>
            </li>
          </ul>
          <p className="talentlenz-applicant-evidence-journey__principle">One application. Structured evidence.</p>
        </div>
      </div>
    </section>
  );
}
